<div class="touareg-bar sidebar w-100 h-100 d-flex">
  <div class="d-flex align-items-center justify-content-end">
    <button class="btn-large" mat-icon-button (click)="close.emit($event)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="px-1 d-flex align-items-center health">
    <button
      class="btn-default btn-large"
      (click)="displayService.healthMonitoringOn()"
    >
      <app-ping class="ping-indicator" [score]="health.minScore"></app-ping>
    </button>
  </div>
</div>
